import { NumberInput, TextInput, required } from 'react-admin';
import { ReactElement } from 'react';
import { RowFormConfigurable } from '@react-admin/ra-editable-datagrid';
import { LabelValueNameInfoLabel, LabelValueValueInfoLabel } from './LabelValueInfoLabel';

interface LabelValueRowFormProps {
  categoryId: string;
  labelId: string;
}

export default function LabelValueRowForm({
  categoryId,
  labelId,
}: LabelValueRowFormProps): ReactElement {
  return (
    <RowFormConfigurable
      defaultValues={{
        type: 'label_values',
        relationships: {
          category: {
            data: {
              id: categoryId,
              type: 'categories',
            },
          },
          label: {
            data: {
              id: labelId,
              type: 'labels',
            },
          },
        },
      }}
    >
      <TextInput
        label={<LabelValueNameInfoLabel />}
        source="attributes.name"
        validate={[required()]}
      />
      <TextInput
        label={<LabelValueValueInfoLabel />}
        source="attributes.value"
        validate={[required()]}
      />
      <NumberInput
        label="Display Order"
        source="attributes.display_order"
        validate={[required()]}
      />
    </RowFormConfigurable>
  );
}
